import { useEffect, useCallback } from 'react';
import RecordType from '../../Models/Locations/recordType';
import useHttp from '../http/useHttp';

export default function useFetchEntityRecordTypes(entityId?: number) {
  const { getDataResponse, getData } = useHttp();

  const init = useCallback(async () => {
    if (!entityId) return;

    await getData(`lookup/getrecordtypes/${entityId}`);
  }, []);

  useEffect(() => {
    if (entityId) {
      init();
    }
  }, []);

  const recordTypesList: RecordType[] = getDataResponse?.data ?? [];

  return { recordTypesList };
}
